import "./App.css";
import Homepage from "./Pages/Homepage";
import { Route } from "react-router-dom";
import Chatpage from "./Pages/Chatpage";
import AdminPage from "./Pages/AdminPage";
import JoinPage from "./Pages/JoinPage";

function App() {
  return (
    <div className="App">
      <Route path="/" component={Homepage} exact />
      <Route path="/chats" component={Chatpage} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/join/:key" component={JoinPage} />
    </div>
  );
}

export default App;
